import React from 'react';
import {
    Modal as BootstrapModal,
    Button as BootstrapButton
} from 'react-bootstrap';
const BootstrapErrorModal = ({
    show,
    title,
    body,
    onClose
}) => (
        <BootstrapModal
            show={show}
            onHide={onClose}
        >
            <BootstrapModal.Header
                closeButton
                style={{
                    backgroundColor: "#a94442", // Taken from current bootstrap theme - update as needed
                    color: '#fff'
                }}
            >
                <BootstrapModal.Title>
                    <i className="fa fa-exclamation-triangle" aria-hidden="true" />&nbsp;{title}
                </BootstrapModal.Title>
            </BootstrapModal.Header>
            <BootstrapModal.Body
                className="text-danger"
            >
                {body}
            </BootstrapModal.Body>
            <BootstrapModal.Footer>
                <BootstrapButton bsStyle="primary" onClick={onClose}>Ok</BootstrapButton>
            </BootstrapModal.Footer>
        </BootstrapModal>
    );

export default BootstrapErrorModal;